import { FC, PropsWithChildren } from 'react';

import classNames from 'classnames';

import { Typography } from '../../Typography/Typography';

import styles from './FormSection.module.scss';

type FormSectionProps = PropsWithChildren<{
  description?: string;
  className?: string;
}>;

export const FormSection: FC<FormSectionProps> = ({
  description,
  children,
}) => {
  const hasDescription = (() => {
    if (typeof description === 'string') {
      return !!description?.trim();
    }
    return false;
  })();

  return (
    <div className={classNames(styles.root)}>
      {hasDescription && (
        <Typography className={styles.description} variant="p2">
          {description}
        </Typography>
      )}
      {children}
    </div>
  );
};
